/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UpgradeDeploymentStatusEnum = 'DEPLOYMENT_UPGRADE_FAILED' | 'DEPLOYMENT_UPGRADE_TRIGGERED' | 'DEPLOYMENT_UPGRADE_IN_PROGRESS' | 'DEPLOYMENT_UPGRADE_SUCCESSFUL' | 'DEPLOYMENT_VERSION_NOT_AVAILABLE' | 'DEPLOYMENT_UPGRADE_CHECK_FAILED' | 'DEPLOYMENT_UPGRADE_CHECK_PASSED' | 'DEPLOYMENT_UPGRADE_PATHS_FOUND' | 'DEPLOYMENT_UPGRADE_DONE_MANUALLY' | 'DEPLOYMENT_NON_DEFAULT_UPGRADE_USE_FORCE' | 'DEPLOYMENT_NOT_IN_READY_STATE' | 'DEPLOYMENT_DOES_NOT_EXIST' | 'DEPLOYMENT_UPGRADE_CURRENT_VERSION_MISMATCH' | 'DEPLOYMENT_UPGRADE_CURRENT_VERSION_DEFAULT' | 'DEPLOYMENT_UPGRADE_CLOUD_PROVIDER_INFO_NOT_FOUND' | 'DEPLOYMENT_UPGRADE_NO_UPGRADE_INFO_FOUND' | 'DEPLOYMENT_UPGRADE_NO_UPGRADE_TRIGGERED' | 'DEPLOYMENT_UPGRADE_ALREADY_IN_TRIGGERED_STATE' | 'DEPLOYMENT_UPGRADE_ALREADY_AT_TARGET_VERSION' | 'DEPLOYMENT_UPGRADE_EC2_INSTANCES_FOUND' | 'DEPLOYMENT_UPGRADE_NO_EC2_INSTANCES_FOUND' | 'DEPLOYMENT_UPGRADE_PATHS_NOT_FOUND' | 'DEPLOYMENT_UPGRADE_INITIAL_FIRST_INSTALL' | 'DEPLOYMENT_UPGRADE_INSTANCES_AT_MIXED_VERSION' | 'DEPLOYMENT_UPGRADE_FAILED_TO_FIND_TARGET_VERSION' | 'UPGRADE_FAILED_TO_FIND_TARGET_RELEASE_IN_DB' | 'DEPLOYMENT_UPGRADE_NON_DEFAULT_SPECIFY_TARGET_VERSION_AND_FORCE' | 'DEPLOYMENT_UPGRADE_MULTIPLE_OPTIONS_SPECIFY_VERSION_AND_FORCE';

export const UpgradeDeploymentStatusEnum = {

    DEPLOYMENT_UPGRADE_FAILED: 'DEPLOYMENT_UPGRADE_FAILED' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_TRIGGERED: 'DEPLOYMENT_UPGRADE_TRIGGERED' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_IN_PROGRESS: 'DEPLOYMENT_UPGRADE_IN_PROGRESS' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_SUCCESSFUL: 'DEPLOYMENT_UPGRADE_SUCCESSFUL' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_VERSION_NOT_AVAILABLE: 'DEPLOYMENT_VERSION_NOT_AVAILABLE' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_CHECK_FAILED: 'DEPLOYMENT_UPGRADE_CHECK_FAILED' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_CHECK_PASSED: 'DEPLOYMENT_UPGRADE_CHECK_PASSED' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_PATHS_FOUND: 'DEPLOYMENT_UPGRADE_PATHS_FOUND' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_DONE_MANUALLY: 'DEPLOYMENT_UPGRADE_DONE_MANUALLY' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_NON_DEFAULT_UPGRADE_USE_FORCE: 'DEPLOYMENT_NON_DEFAULT_UPGRADE_USE_FORCE' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_NOT_IN_READY_STATE: 'DEPLOYMENT_NOT_IN_READY_STATE' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_DOES_NOT_EXIST: 'DEPLOYMENT_DOES_NOT_EXIST' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_CURRENT_VERSION_MISMATCH: 'DEPLOYMENT_UPGRADE_CURRENT_VERSION_MISMATCH' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_CURRENT_VERSION_DEFAULT: 'DEPLOYMENT_UPGRADE_CURRENT_VERSION_DEFAULT' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_CLOUD_PROVIDER_INFO_NOT_FOUND: 'DEPLOYMENT_UPGRADE_CLOUD_PROVIDER_INFO_NOT_FOUND' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_NO_UPGRADE_INFO_FOUND: 'DEPLOYMENT_UPGRADE_NO_UPGRADE_INFO_FOUND' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_NO_UPGRADE_TRIGGERED: 'DEPLOYMENT_UPGRADE_NO_UPGRADE_TRIGGERED' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_ALREADY_IN_TRIGGERED_STATE: 'DEPLOYMENT_UPGRADE_ALREADY_IN_TRIGGERED_STATE' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_ALREADY_AT_TARGET_VERSION: 'DEPLOYMENT_UPGRADE_ALREADY_AT_TARGET_VERSION' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_EC2_INSTANCES_FOUND: 'DEPLOYMENT_UPGRADE_EC2_INSTANCES_FOUND' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_NO_EC2_INSTANCES_FOUND: 'DEPLOYMENT_UPGRADE_NO_EC2_INSTANCES_FOUND' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_PATHS_NOT_FOUND: 'DEPLOYMENT_UPGRADE_PATHS_NOT_FOUND' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_INITIAL_FIRST_INSTALL: 'DEPLOYMENT_UPGRADE_INITIAL_FIRST_INSTALL' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_INSTANCES_AT_MIXED_VERSION: 'DEPLOYMENT_UPGRADE_INSTANCES_AT_MIXED_VERSION' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_FAILED_TO_FIND_TARGET_VERSION: 'DEPLOYMENT_UPGRADE_FAILED_TO_FIND_TARGET_VERSION' as UpgradeDeploymentStatusEnum,

    UPGRADE_FAILED_TO_FIND_TARGET_RELEASE_IN_DB: 'UPGRADE_FAILED_TO_FIND_TARGET_RELEASE_IN_DB' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_NON_DEFAULT_SPECIFY_TARGET_VERSION_AND_FORCE: 'DEPLOYMENT_UPGRADE_NON_DEFAULT_SPECIFY_TARGET_VERSION_AND_FORCE' as UpgradeDeploymentStatusEnum,

    DEPLOYMENT_UPGRADE_MULTIPLE_OPTIONS_SPECIFY_VERSION_AND_FORCE: 'DEPLOYMENT_UPGRADE_MULTIPLE_OPTIONS_SPECIFY_VERSION_AND_FORCE' as UpgradeDeploymentStatusEnum
};

